import React from 'react';
import { Box, Pagination } from '@mui/material';
import { FEEDBACK_PAGE_SIZE } from '../constants';

type FeedbackListPaginationProps = {
  page: number;
  totalCount: number;
  onPageChange: (page: number) => void;
};

export const FeedbackListPagination: React.FC<FeedbackListPaginationProps> = ({
  page,
  totalCount,
  onPageChange,
}) => {
  const pageCount = Math.ceil(totalCount / FEEDBACK_PAGE_SIZE);
  if (pageCount <= 1) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
      <Pagination
        count={pageCount}
        page={page}
        onChange={(_, value) => onPageChange(value)}
        size="small"
        color="primary"
      />
    </Box>
  );
};
